import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            errorCount: 0
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'development') {
            console.error('Error caught by boundary:', error, errorInfo);
        }

        this.setState(prevState => ({
            errorInfo,
            errorCount: prevState.errorCount + 1
        }));
    }

    handleReset = () => {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="container my-5">
                    <div className="alert alert-danger" role="alert">
                        <div className="d-flex align-items-center mb-3">
                            <FontAwesomeIcon
                                icon={faExclamationTriangle}
                                className="me-2"
                                size="lg"
                            />
                            <h4 className="mb-0">Something went wrong</h4>
                        </div>

                        <p className="mb-3">
                            An unexpected error occurred. Please try refreshing the page or contact support if the problem persists.
                        </p>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details style={{ whiteSpace: 'pre-wrap', marginBottom: '1rem' }}>
                                <summary>Error Details (Development Only)</summary>
                                <div style={{
                                    backgroundColor: '#f5f5f5',
                                    padding: '1rem',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    maxHeight: '300px',
                                    overflow: 'auto'
                                }}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo?.componentStack}
                                </div>
                            </details>
                        )}

                        <div>
                            <button
                                className="btn btn-primary me-2"
                                onClick={this.handleReset}
                            >
                                Try Again
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={() => window.location.href = '/'}
                            >
                                Go Home
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
